/**
 * Shared horizontal rhythm of the home page, so the coloured bands (story panel, « Qui
 * êtes-vous ? », trust) share one edge on every screen instead of each section picking its
 * own width. Full class strings on purpose: Tailwind only generates classes it can read
 * literally in the source.
 */

/** Side padding of a home section: the same gutter above every band. */
export const SECTION_GUTTER = "px-4 sm:px-8 xl:px-10";

/** Width of a full coloured band, grown once on very wide screens. */
export const BAND_WIDTH = "max-w-[1600px] min-[2200px]:max-w-[1920px]";

/** Width of the content under a band (cards, plans): narrower than the band, same steps everywhere. */
export const CONTENT_WIDTH = "max-w-6xl xl:max-w-7xl 2xl:max-w-[1440px]";
